export default __webpack_public_path__ + "static/media/default.23850a7140008f017388d0d7b56eda43.png";